import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Inter ospitato da noi: caricarlo da Google mandava a Google l'indirizzo di
// ogni host che apriva l'app, senza che l'avesse accettato (GDPR).
import "@fontsource-variable/inter/wght.css";
import "./styles.css";
import { App } from "./App.tsx";
import { StoreProvider } from "./lib/store.tsx";

const root = document.getElementById("root");
if (!root) throw new Error("Elemento #root mancante");

createRoot(root).render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>,
);

// Il service worker serve a una cosa sola: far installare Otto come app sul
// telefono. Solo nella versione compilata: in sviluppo Vite serve i file da
// sé, e un worker in mezzo nasconderebbe le modifiche appena fatte.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Senza, l'app funziona lo stesso: si perde solo «Aggiungi a Home».
    });
  });
}
